<ws-modal-wrapper
    [headerLabel]="title"
    (save)="apply(true)"
    (auxButton)="applySome()"
    (cancel)="cancel()"
    acceptLabel="Apply All"
    [auxButtonLabel]="isCheckboxesEnabled ? 'Apply Selected' : null"
    [cancelLabel]="params.disableApplyAll ? 'Close' : 'Cancel'"
    [disableAuxButton]="!atLeastOneSelected || params.disableApplyAll"
    [disableSave]="params.disableApplyAll"
>
    <div>
        <div style="display: flex; gap: 15px; align-items: center">
            <h5>Appeal Deadline: {{ appealDeadline | date: 'M/d/yyyy' : 'utc' }}</h5>
            @if (isCheckboxesEnabled && appealDeadline) {
                <div class="checkbox">
                    <label>
                        <input type="checkbox" [disabled]="params.disableApplyAll" [(ngModel)]="appealDeadlineApply" />
                    </label>
                </div>
            }
        </div>
        <table class="ace-table w-100 mt-3">
            <thead>
                @for (col of tableColumns; track col) {
                    <th class="px-4 border-bottom ws-vertical-align-middle" [class.text-align-right]="col.isNum">
                        <span class="m-0 p-0">{{ col.name }}</span>
                    </th>
                }
                <th class="border-bottom"></th>
                <th></th>
            </thead>
            <tbody>
                @for (row of rows; track row; let i = $index) {
                    <tr
                        (mouseenter)="hoveredRow = row"
                        (mouseleave)="hoveredRow = null"
                        [style.font-weight]="row.type === 'Total' ? 'bold' : 'normal'"
                    >
                        <td class="px-4 py-0 border-0 ws-vertical-align-middle">
                            <div class="cell-contents d-flex align-items-center">
                                {{ row.type }}
                            </div>
                        </td>
                        <td class="px-4 py-0 border-0 ws-vertical-align-middle">
                            <div class="cell-contents d-flex align-items-center">
                                {{ row.name }}
                            </div>
                        </td>
                        <td class="px-4 py-0 border-0 ws-vertical-align-middle">
                            <div class="cell-contents d-flex align-items-center justify-content-end">
                                {{ row.av | currency: 'USD' : 'symbol' : '1.0-0' }}
                            </div>
                        </td>
                        <td class="px-4 py-0 border-0 ws-vertical-align-middle">
                            <div class="cell-contents d-flex align-items-center justify-content-end">
                                {{ row.ratio }}
                            </div>
                        </td>
                        <td class="px-4 py-0 border-0 ws-vertical-align-middle">
                            <div class="cell-contents d-flex align-items-center justify-content-end">
                                {{ row.fmv | currency: 'USD' : 'symbol' : '1.0-0' }}
                            </div>
                        </td>
                        <td class="px-4 py-0 border-0" style="vertical-align: middle">
                            @if (row.explanation) {
                                <div class="row-actions">
                                    <i
                                        class="fa fa-info-circle"
                                        [popover]="row.explanation"
                                        container="body"
                                        triggers="mouseenter:mouseleave"
                                    ></i>
                                </div>
                            }
                        </td>
                        <td>
                            @if (isCheckboxesEnabled && row.type !== 'Total' && (row.av || row.ratio || row.fmv)) {
                                <div class="checkbox">
                                    <label>
                                        <input
                                            type="checkbox"
                                            style="margin-top: 6px"
                                            [disabled]="row.type === 'Total' || params.disableApplyAll"
                                            [(ngModel)]="row.apply"
                                        />
                                    </label>
                                </div>
                            }
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
</ws-modal-wrapper>
